import { AUTH_TYPE_KEY, AUTH_TYPES } from '@brightdrop/auth-client';
import { Route, useLocation } from 'react-router-dom';

import { AppRoutePaths } from '~/common/models/route.model';

import Login from './login/Login';
import Logout from './logout/Logout';

// remove SsoRedirect & CdiRedirect May 1st 2026
const SsoRedirect = () => {
  const { search, hash } = useLocation();
  const url = new URL(AppRoutePaths.LOGIN, window.location.origin);
  const searchParams = new URLSearchParams(search);
  searchParams.set(AUTH_TYPE_KEY, AUTH_TYPES.SSO.valueOf());
  url.search = searchParams.toString();
  url.hash = hash;
  window.location.href = url.toString();
  return null;
};

const CdiRedirect = () => {
  const { search, hash } = useLocation();
  const url = new URL(AppRoutePaths.LOGIN, window.location.origin);
  const searchParams = new URLSearchParams(search);
  url.search = searchParams.toString();
  url.hash = hash;
  window.location.href = url.toString();
  return null;
};

const Auth = (
  <>
    <Route path={AppRoutePaths.LOGOUT} element={<Logout />} />
    <Route path={AppRoutePaths.LOGIN} element={<Login />} />
    <Route path="/login-sso" element={<SsoRedirect />} />
    <Route path="/login/sso" element={<SsoRedirect />} />
    <Route path="/auth/sso/login" element={<SsoRedirect />} />
    <Route path="/auth/cdi/login" element={<CdiRedirect />} />
  </>
);

export default Auth;
